import { css, html, LitElement } from 'lit';
import { customElement, property, query } from 'lit/decorators';
import lottie from 'lottie-web/build/player/lottie_light';
import { AnimationItem } from 'lottie-web';
const animationDataAsync = import('@APP/views/animations/Ahoy_loader.json');

@customElement('ahoy-loader')
export class AhoyLoader extends LitElement {

  @query('.animation-loader')
    container?: HTMLElement;

  @property({ type: String, reflect: true, attribute: 'loader-text' })
    loaderText = '';

  @property({ type: String, reflect: true, attribute: 'loader-text-1' })
    loaderText1 = '';
  
  @property({ type: String, reflect: true, attribute: 'loader-text-2' })
    loaderText2 = '';
  
  @property({ type: String, reflect: true, attribute: 'loader-text-3' })
    loaderText3 = '';
  
  @property({ type: String, reflect: true, attribute: 'loader-text-4' })
    loaderText4 = '';

  animation?: AnimationItem;

  firstUpdated() {
    animationDataAsync.then((animationData) => {
      this.animation = lottie.loadAnimation({
        container: this.container!,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
      this.animation.play();
    });
  }

  updated(changedProperties: Map<string | number | symbol, unknown>) {
    if (changedProperties.has('loaderText')) {
      if (this.loaderText === 'Uploading image rotate text') {
        this.changeText();
      }
    }
  }

  connectedCallback() {
    super.connectedCallback();
    this.loaderText1 = 'Uploading image...';
    this.loaderText2 = 'Extracting image...';
    this.loaderText3 = 'Finding similar boat...';
    this.loaderText4 = 'Loading data...';}
  
  private changeText() {
    // switch the loader text every 2 seconds between the 4 texts    
    this.loaderText = this.loaderText1;
    setTimeout(() => {
      this.loaderText = this.loaderText2;
    }, 4000);
    setTimeout(() => {
      this.loaderText = this.loaderText3;
    }, 8000);
    setTimeout(() => {
      this.loaderText = this.loaderText4;
    }, 12000);
    ;
  }

  static get styles() {
    return [css`
      .overlay {
        position: fixed;
        display: flex;
        flex-flow:column;
        left: 0;
      top: 0;
      width: 100vw;
      height: 100vh;
      background: rgba(255, 255, 255, 0.28);
      backdrop-filter: blur(5px);
      z-index: 100;
      align-items: center;
      align-content: center;
      justify-content: center;
      pointer-events: none;
    }
    
    .animation-loader {
      width: 150px;
      height: 150px;
    }

    .animation-loader.mobile {
      width: 60px;
      height: 60px;
    }

    .text{
      font-size:4rem;
      color: var(--d2l-loading-spinner-color, var(--d2l-color-celestine));
      margin-block-start: 1rem;
    }

    .text.mobile{
      font-size:2rem;
    }
  `];
  };

  render() {
    const isMobile = window.innerWidth < 768;
    return html`
      <div class="overlay">
        <div class="animation-loader ${isMobile? 'mobile': ''}"></div>
        ${this.loaderText ? html`<div class="text ${isMobile? 'mobile': ''}">${this.loaderText}</div>` : ''}
      </div>
    `;
  }
}